import Nav from "./components/Nav";
import Hero from "./components/Hero";
import HotTrends from "./components/HotTrends";
import Overview from "./components/Overview";
import Controversy from "./components/Controversy";
import CommentBoard from "./components/CommentBoard";
import Timeline from "./components/Timeline";
import Vote from "./components/Vote";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <Nav />
      <main>
        <Hero />
        <HotTrends />
        <Overview />
        <Controversy />
        <CommentBoard />
        <Timeline />
        <Vote />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}